<template>
  <MultiJumpContainer
    v-if="cardInfo"
    :biTag="cardInfo.title"
    :jumpInfo="{
      jumpUrl: getJumpUrl(cardInfo),
      appid: cardInfo.appid,
      username: cardInfo.username,
      path: cardInfo.path,
    }"
    :extraData="cardInfo.customEventKey"
    @customEventClick="onClick"
  >
    <div :class="[isRowCard ? 'theme-row-card-wrapper' : 'theme-card-wrapper']">
      <ImageLoader class="logo" :src="cardInfo.logo" alt="" />
      <div class="title">{{ cardInfo.title }}</div>
      <div v-if="!isRowCard && isShowCardDesc" class="desc">{{ cardInfo.desc }}</div>
    </div>
  </MultiJumpContainer>
</template>

<script setup lang="ts">
import { ImageLoader } from '@tencent/wphk-components-content-loader';
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';
import { getJumpUrl } from '@/utils';
import { ThemeCardType } from '@/types';
import { computed } from 'vue';

// 暂时不能从外部引入声明：https://cn.vuejs.org/api/sfc-script-setup.html#typescript-only-features
type CardWithEvent = {
  title: string;
  desc: string;
  logo: string;
  url?: string;
  appid?: string;
  username?: string;
  path?: string;
  customEventKey?: string;
};

const props = defineProps({
  cardInfo: {
    type: Object as () => CardWithEvent,
    required: true,
  },
  cardType: {
    type: String as () => ThemeCardType,
    default: () => ThemeCardType.column,
  },
  isShowCardDesc: {
    type: Boolean,
    default: true,
  },
});
const emits = defineEmits(['themeCardClick']);

// 是否是横版样式卡片
const isRowCard = computed(() => props.cardType === ThemeCardType.row);

function onClick(data) {
  emits('themeCardClick', data);
}
</script>

<style lang="less" scoped>
@import (reference) '~@/less/main';
.theme-row-card-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  .logo {
    width: 72 / @rem;
    height: 72 / @rem;
    margin-right: 16 / @rem;
  }
  .title {
    flex: 1;
    width: 100%;
    .font-32-medium(rgba(0, 0, 0, 0.9));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.theme-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo {
    width: 80 / @rem;
    height: 80 / @rem;
    margin-bottom: 8 / @rem;
  }
  .title {
    width: 100%;
    .font-28-medium(rgba(0, 0, 0, 0.9));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .desc {
    .font-24-regular(rgba(0,0,0,0.5));
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
  }
}
</style>
